<template>
    <div>
        <div class="row mt-3">
            <div class="col-lg-4 col-12 mt-3 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">شماره سند</span>
                    </div>
                    <input class="form-control" type="number"
                           v-model="activePayment.voucherNumber" :placeholder="lastVoucherNumber">
                </div>
            </div>
            <div class="col-lg-4 col-12 mt-3">
                <div class=" d-inline-block ">
                    <div class="input-group ">
                        <div class="input-group-prepend " @click="toggleStartDatePicker2">
                            <div class="input-group-text"><span>تاریخ</span></div>
                        </div>
                        <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"
                                     ref="datePickerStart2" style="flex: 1">
                            <slot>
                                <input v-model="voucherDatePersian" class="form-control date-input" readonly="true"
                                       @click="toggleStartDatePicker2">
                                <button class="close reset-date" @click="resetStartDate">×</button>
                            </slot>
                        </date-picker>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-12 mt-3 d-inline-flex">
                <button type="button" class="btn btn-success w-100 mx-1" @click="onPaymentModalOk">ثبت سند</button>
                <button type="button" class="btn btn-danger mx-1" @click="onCancelClicked" title="انصراف">X</button>
            </div>
            <div class="col-lg-12 col-12 mt-3 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">شرح کلی</span>
                    </div>
                    <input class="form-control" type="text"
                           v-model="activePayment.description" placeholder="توضیحات کلی سند">
                </div>
            </div>

            <hr class="w-100"/>

            <!--<div class="col-lg-2 col-12 mt-3 d-inline-block">-->
            <!--<h5>دریافت از (بستانکار)</h5>-->
            <!--</div>-->
            <div class="col-lg-3 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">سرفصل</span>
                    </div>
                    <vs-select :data="mainAccounts" :mode="'create'"
                               :selected-val="mainSel1"
                               :header="{multiple: false, label: 'title'}"
                               @onChange="onDept1Select"></vs-select>
                </div>
            </div>
            <div class="col-lg-3 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">زیر سرفصل :</span>
                    </div>
                    <vs-select :data="cashs1" :mode="'create'"
                               :selected-val="secSell1"
                               :header="{multiple: false, label: 'outSourceName'}"
                               @onChange="onDept2Select"></vs-select>
                </div>
            </div>
            <div class="col-lg-3 col-12 mt-2 d-inline-block">

                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">بدهکار</span>
                    </div>
                    <input class="form-control" type="number"
                           v-model="price1" placeholder="بدهکار" @input="thousandSepratorReturn1(price1)">
                </div>
                <small class="text-nowrap mt-2 offset-3">{{price1show}}</small>
            </div>
            <div class="col-lg-3 col-12 mt-2 d-inline-block">

                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">بستانکار</span>
                    </div>
                    <input class="form-control" type="number"
                           v-model="price2" placeholder="بستانکار" @input="thousandSepratorReturn2(price2)">
                </div>
                <small class="text-nowrap mt-2 offset-3">{{price2show}}</small>
            </div>


            <div class="col-lg-9 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">توضیحات</span>
                    </div>
                    <input class="form-control" type="text"
                           v-model="des1" placeholder="توضیحات">
                </div>
            </div>
            <div class="col-lg-3 col-12 mt-2  d-inline-block">
                <button class="btn btn-success w-100" @click="add1">افزودن به جدول</button>
            </div>
            <!--////////////////         ///////////////////////////////////////-->
            <!--////////////////         ///////////////////////////////////////-->
            <!--////////////////         ///////////////////////////////////////-->
            <hr class="w-100"/>

            <!--////////////////         ///////////////////////////////////////-->
            <!--////////////////         ///////////////////////////////////////-->
            <hr class="w-100"/>


            <h6 class="w-100 text-center" v-if="paymentList.length == 0">هیچ ردیفی ثبت نشده است</h6>
            <div class="w-100" v-else>
                <div class="table-responsive">
                    <table class="table table-hover table-striped">
                        <thead>
                        <tr>
                            <th class=" text-nowrap">نام</th>
                            <th class="text-center text-nowrap">کد</th>
                            <th class="text-center text-nowrap">شرح</th>
                            <th class="text-center text-nowrap">بدهکار</th>
                            <th class="text-center  text-nowrap">بستانکار</th>
                            <th class="text-center  text-nowrap">عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in paymentList">
                            <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                            <td>{{item.code === ""? item.toCodeName:item.codeName}}</td>
                            <!--<td class="text-center">-->
                            <!--{{item.price.toLocaleString()}}-->
                            <!--</td>-->
                            <td class="text-center">
                                {{item.code === ""? item.toCode:item.code}}
                            </td>
                            <td class="text-center">
                                {{item.description}}
                            </td>
                            <td class="text-center">
                                {{item.code === ""? item.price.toLocaleString():"---"}}
                            </td>
                            <td class="text-center">
                                {{item.code === ""?"---": item.price.toLocaleString()}}
                            </td>
                            <td class="text-center">
                                <button class="btn btn-warning" @click="editRow(item)"><i class="fa fa-pencil"></i></button>
                                <button class="btn btn-danger" @click="minus(item)"><i class="fa fa-minus"></i></button>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-right" colspan="3"><b>جمع کل</b></td>
                            <td class="text-center"><b>{{totalDebt.toLocaleString()}}</b></td>
                            <td class="text-center"><b>{{totalCreat.toLocaleString()}}</b></td>

                        </tr>
                        <tr>
                            <td class="text-right" colspan="4"><b>باقیمانده</b></td>
                            <td class="text-center"><b>{{remainAmount>=0? remainAmount.toLocaleString():"("+remainAmount*-1+"-)"}}</b></td>

                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>


        <div class="modal fade" id="transaction" tabindex="-1" role="dialog" aria-labelledby="transactionTitle"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-danger-grad glow-danger">
                        <h5 class="modal-title text-white" id="transactionTitle">خلاصه تراکنش</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="table-responsive modal-body" id="printMe">
                        <table class="table table-bordered">
                            <tbody>
                            <!--<tr>-->
                            <!--<td>-->
                            <!--<strong>دریافت از (بستانکار)</strong>-->
                            <!--</td>-->
                            <!--<td>-->
                            <!--<span>{{activePayment.name}}</span>-->
                            <!--</td>-->
                            <!--</tr>-->
                            <!--<tr>-->
                            <!--<td>-->
                            <!--<strong>واریز به (بدهکار)</strong>-->
                            <!--</td>-->
                            <!--<td>-->
                            <!--<span>{{activePayment.toName}}</span>-->
                            <!--</td>-->
                            <!--</tr>-->
                            <tr>
                                <td>
                                    <strong>مبلغ</strong>
                                </td>
                                <td>
                                    <!--<span>{{activePayment.price.toLocaleString()}}</span>-->
                                    <span>{{thousandSepratorprint(activePayment.price)}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>توضیحات</strong>
                                </td>
                                <td>
                                    <!--<span>{{activePayment.price.toLocaleString()}}</span>-->
                                    <input class="form-control" type="text" v-model="activePayment.description">
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>تاریخ</strong>
                                </td>
                                <td>
                                    <div class="input-group mt-2">
                                        <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"
                                                     ref="datePickerStart" style="flex: 1">
                                            <slot>
                                                <input v-model="voucherDatePersian" class="form-control date-input" readonly="true"
                                                       @click="toggleStartDatePicker">
                                                <button class="close reset-date" @click="resetStartDate">×</button>
                                            </slot>
                                        </date-picker>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-primary" @click="onConfirmationModalOk">تایید</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import VsSelect from "../../_framework/VsSelect"
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import Moment from 'moment-jalali';
    import VueHtmlToPaper from 'vue-html-to-paper';

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'addPayment',
        components: {
            DatePicker,
            VsSelect,
        },
        data() {
            return {
                fromEdit: false,
                voucher: null,
                price1: 0,
                price1show: 0,
                price2: 0,
                price2show: 0,
                banks: [],
                cashDesks: [],
                checkBooks: [],

                transactionType: "",
                remainingAmount: 0,

                activePayment: {
                    lastId: 0,
                    code: "",
                    price: 0,
                    name: "",
                    check: {
                        checkNumber: "",
                        checkDate: "",
                        checkPersianDate: "",
                        bankName: "",
                        branchName: "",
                        branchCode: ""
                    },
                    voucherDate: "0001-01-01",
                    voucherNumber: null,
                    fromCode: "",
                    toCode: "",
                    toName: "",
                    description: "",
                    paymentList: [],
                },
                paymentList: [
                    // {
                    //     code: "",
                    //     codeName: "",
                    //     price: 0,
                    //     toCode: "",
                    //     toCodeName: "",
                    // }
                ],
                remainAmount: 0,
                totalDebt: 0,
                totalCreat: 0,
                hasCheck: false,
                archivedVoucher: false,
                customerChecks: [],

                payments: [],
                customers: [],


                queryParams: {
                    pageSize: 10000,
                    pageIndex: 0,

                },
                queryParams1: {
                    pageSize: 10000,
                    pageIndex: 0,
                    parrentId: 1
                },
                queryParams2: {
                    pageSize: 10000,
                    pageIndex: 0,
                    parrentId: 1
                },
                selectedMain1: 0,
                selectedMain2: 0,
                selectedCash1: 0,
                selectedCash2: 0,
                keepData: false,
                showCash: false,
                isDetail: false,
                mainSel1: {},
                mainSel2: "",
                secSell1: {},
                secSell2: "",
                des1: "",
                des2: "",

                fromTitle: "",
                toTitle: "",
                isSending: false,

                voucherDatePersian: "",
                mainAccounts: [],
                //     {id: 0, title: "همه حسابها"},
                //     {id: 1, title: "بانکها"},
                //     {id: 2, title: "صندوق ها"},
                //     {id: 3, title: "مشتری ها"},
                //     {id: 5, title: "تامین کننده ها"},
                //     {id: 6, title: "سرمایه(موجودی اولیه)"},
                //     {id: 7, title: "درآمدها"},
                //     {id: 8, title: "هزینه ها"},
                //     // {id: 9, title: "تولید"},
                //     {id: 10, title: "فروش"},
                //     {id: 11, title: "خرید"},
                //     {id: 12, title: "چک های دریافتی"},
                //     {id: 13, title: "چک های پرداختی"},
                //     {id: 20, title: "سایر سرفصلها"},
                //     // {id: 14, title: "فروش اینترنتی"},
                // ],
                cashs1: [],
                cashs2: [],
                showprice: 0,
                lastVoucherNumber: "",
            }
        },
        mounted() {
            const cc = localStorage.getItem("salemali_close");
            if (cc !== undefined && cc != null && cc === "true") {
                Utils.handleErrorWithNotification("سال مالی بسته شده است و امکان ثبت جدید وجود ندارد", this.$noty);
            }
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);

            new BaseService('voucher/getlastVoucherNumber/20').getList().then(response => {
                this.lastVoucherNumber = response.data;
                if (this.lastVoucherNumber !== undefined && this.lastVoucherNumber !== null && this.lastVoucherNumber > 0) {
                    this.lastVoucherNumber++;
                    this.lastVoucherNumber = "اگر خالی بگذارید بصورت اتوماتیک " + this.lastVoucherNumber + " وارد میشود";
                }else{
                    this.lastVoucherNumber =100;
                }
            }).catch(error => {
                // error
                this.lastVoucherNumber =100;
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });

            let tod = Moment(new Date()).format('YYYY-MM-DD');
            this.activePayment.voucherDate = tod;
            this.voucherDatePersian = Moment(tod, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
            if (this.$route.params !== undefined && this.$route.params !== null && this.$route.params.voucher != undefined && this.$route.params.voucher !== null) {
                this.voucher = this.$route.params.voucher;
                console.log("sala", this.voucher)
                this.fromEdit = true;
                this.voucherDatePersian = Moment(this.voucher.voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                this.activePayment.voucherDate = this.voucher.voucherDate;
                this.activePayment.lastId = this.voucher.id;
                this.activePayment.description = this.voucher.description;
                this.activePayment.price = this.voucher.price;
                this.activePayment.toCode = this.voucher.serveOutSourceId;
                for (let i of this.voucher.journals) {
                    let a = {
                        code: i.creditor !== 0 ? i.accountTitleCode : "",
                        codeName: i.creditor !== 0 ? i.outSourceName : "",
                        price: parseInt(i.debtor !== 0 ? i.debtor : i.creditor !== 0 ? i.creditor : 0),
                        toCode: i.debtor !== 0 ? i.accountTitleCode : "",
                        toCodeName: i.debtor !== 0 ? i.outSourceName : "",
                        description: i.description,
                    };
                    this.paymentList.push(a);
                    this.remainAmount -= parseInt(i.debtor);
                    this.remainAmount += parseInt(i.creditor);

                    this.totalDebt += parseInt(i.debtor);
                    this.totalCreat += parseInt(i.creditor);

                }

            }

            this.getAllMains();
        },
        methods: {
            getAllMains() {
                new BaseService('AccountTitle', '/GetAllHead').getList().then(response => {
                    let a = response.data;
                    this.mainAccounts = [];
                    let bb = {id: 0, title: "همه حسابها", code: 0};
                    this.mainAccounts.push(bb);
                    for (let i of a) {
                        switch (i.id) {
                            case 1:
                                i.title = "بانکها";
                                break;
                            case 2:
                                i.title = "صندوق ها";
                                break;
                            case 3:
                                i.title = "مشتری ها";
                                break;
                            case 4:
                                i.title = "اشخاص";
                                break;
                            case 5:
                                i.title = "تامین کننده ها";
                                break;
                            case 6:
                                i.title = "سرمایه(موجودی اولیه)";
                                break;
                            case 7:
                                i.title = "درآمدها";
                                break;
                            case 8:
                                i.title = "هزینه ها";
                                break;
                            case 10:
                                i.title = "فروش";
                                break;
                            case 11:
                                i.title = "خرید";
                                break;
                            case 12:
                                i.title = "چک های دریافتی";
                                break;
                            case 13:
                                i.title = "چک های پرداختی";
                                break;
                            case 14:
                                i.title = "";
                                break;
                            case 15:
                                i.title = "موجودی اولیه کالا";
                                break;
                            case 16:
                                i.title = "شرکاء";
                                break;
                            case 17:
                                i.title = "دارائی ها";
                                break;
                            case 18:
                                i.title = "بدهی ها";
                                break;
                            case 20:
                                i.title = "سرفصلهای حسابداری";
                                break;

                        }
                        this.mainAccounts.push(i);
                    }
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },

            findCode(mainText) {
                let code = mainText.substring(0, mainText.indexOf("9"));
                switch (parseInt(code)) {
                    case 1:
                        return "بانک";
                    case 2:
                        return "صندوق";
                    case 3:
                        return "مشتری";

                    case 5:
                        return "تامین کننده";
                    // case 6:
                    //    return "بانک";
                    case 7:
                        return "درآمد";
                    case 8:
                        return "هزینه";
                    // case 10:
                    //    return "بانک";
                    // case 11:
                    //    return "بانک";
                    // case 12:
                    //    return "بانک";
                    // case 13:
                    //    return "بانک";
                    case 14:
                        return "خرید آنلاین";
                }
            },
            onCardClicked(e, index, type) {
                this.activePayment.name = "";
                this.activePayment.code = "";
                this.activePayment.price = 0;
                if (type === 'bank') {
                    this.activePayment.name = this.banks[index].outSourceName;
                    this.activePayment.code = this.banks[index].code;
                    this.activePayment.usedCheck = false;
                    if (this.fromTitle === "") {
                        this.fromTitle = "بانک";
                    } else {
                        this.toTitle = "بانک";
                    }
                    $("#payment").modal("show");
                }
                if (type === 'cashDesk') {
                    this.activePayment.name = this.cashDesks[index].outSourceName;
                    this.activePayment.code = this.cashDesks[index].code;
                    this.activePayment.usedCheck = false;
                    if (this.fromTitle === "") {
                        this.fromTitle = "صندوق";
                    } else {
                        this.toTitle = "صندوق";
                    }
                    $("#payment").modal("show");
                }
                if (type === 'checkBook') {
                    this.activePayment.name = this.checkBooks[index].outSourceName;
                    this.activePayment.code = this.checkBooks[index].code;
                    this.activePayment.price = this.checkBooks[index].price;
                    this.activePayment.usedCheck = true;
                    if (this.fromTitle === "") {
                        this.fromTitle = "چک";
                    } else {
                        this.toTitle = "چک";
                    }
                    this.onPaymentModalOk();
                }
                /*for (let item of this.payments) {
                    if (item.code === this.activePayment.code) {
                        this.activePayment.price = item.price;
                    }
                }*/
            },
            /*onModalShow() {
                $("#voucherData").modal("show");
            },
            onModalEditClicked() {
                $("#voucherData").modal("hide");
                if (this.transactionType === "buy") {
                    let obj = {
                        name: 'buy-from-outsource',
                        params: {
                            id: this.voucher.serveOutSourceId,
                            voucher: this.voucher
                        }
                    };
                    this.$router.push(obj);
                } else {
                    let obj = {
                        name: 'sell',
                        params: {
                            voucher: this.voucher
                        }
                    };
                    this.$router.push(obj);
                }
            },*/
            onPaymentModalOk() {
                if (this.activePayment.code === "") {
                    this.$noty.error("لطفا پرداخت کننده را انتخاب کنید.");
                } else if (this.activePayment.toCode === "") {
                    this.$noty.error("لطفا دریافت کننده را انتخاب کنید.");
                } else if (this.activePayment.price === 0) {
                    this.$noty.error("لطفا مبلغ را وارد کنید.");
                } else if (this.remainAmount !== 0) {
                    this.$noty.error("مجموع دریافت و پرداخت بایستی صفر بشود.");
                } else {
                    console.log(this.activePayment)
                    $("#payment").modal('hide');
                    $("#transaction").modal('show');
                }
            },
            onConfirmationModalOk() {
                if (this.activePayment.voucherDate === undefined || this.activePayment.voucherDate === null || this.activePayment.voucherDate === "" || this.activePayment.voucherDate === "0001-01-01") {
                    this.activePayment.voucherDate = Moment(new Date()).format('YYYY-MM-DD');
                }
                if (this.checkVoucherDateInSalemali(this.activePayment.voucherDate)) {
                    if (this.activePayment.code === "") {
                        this.$noty.error("لطفا پرداخت کننده را انتخاب کنید.");
                    } else if (this.activePayment.toCode === "") {
                        this.$noty.error("لطفا دریافت کننده را انتخاب کنید.");
                    } else if (this.activePayment.price === 0) {
                        this.$noty.error("لطفا مبلغ را وارد کنید.");
                    } else if (this.remainAmount !== 0) {
                        this.$noty.error("باقیمانده بایستی صفر باشد.");
                    } else {
                        if (!this.isSending) {
                            this.isSending = true;
                            if (this.activePayment.check != null && this.activePayment.check !== undefined) {
                                if (this.activePayment.check.checkNumber === "") {
                                    this.activePayment.check = null;
                                }
                            }
                            this.activePayment.paymentList = this.paymentList;
                            if (this.fromEdit && this.activePayment.lastId !== 0) {
                                new BaseService('payment/updatePaymentList').update(this.activePayment).then(response => {
                                    this.$noty.success("تراکنش با موفقیت ویرایش شد.");
                                    this.isSending = false;
                                    $("#transaction").modal('hide');
                                    this.paymentList = [];
                                    this.activePayment.fromCode = "";
                                    this.activePayment.toCode = "";
                                    this.activePayment.price = 0;
                                    this.activePayment.description = "";
                                    this.activePayment.VoucherNumber = "";
                                    this.selectedMain1 = 0;
                                    this.secSell1 = {};
                                    this.selectedMain2 = 0;
                                    this.secSell2 = "";
                                    this.$router.push({name: 'accountPaymentList'});
                                }).catch(error => {
                                    this.isSending = false;
                                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                                });
                            } else {
                                new BaseService('payment/createPaymentList').create(this.activePayment).then(response => {
                                    this.$noty.success("تراکنش با موفقیت ثبت شد.");
                                    this.isSending = false;
                                    $("#transaction").modal('hide');
                                    this.paymentList = [];
                                    this.activePayment.fromCode = "";
                                    this.activePayment.toCode = "";
                                    this.activePayment.price = 0;
                                    this.activePayment.description = "";
                                    this.activePayment.VoucherNumber = "";
                                    this.selectedMain1 = 0;
                                    this.secSell1 = {};
                                    this.selectedMain2 = 0;
                                    this.secSell2 = "";
                                    this.$router.push({name: 'accountPaymentList'});
                                }).catch(error => {
                                    this.isSending = false;
                                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                                });
                            }
                        }
                    }
                }
            },
            onCancelClicked() {
                this.$router.push({name: 'accountPaymentList'});
            },
            onRemovePaymentClicked(index) {
                this.payments.splice(index, 1);
            },
            /*isActive(object) {
                for (let item of this.payments) {
                    if (item.code === object.code) {
                        return true;
                    }
                }
                return false;
            },*/
            onBankChange(val) {
                this.toTitle = "دریافت چک";
                this.activePayment.check.bankName = val.name;
                this.activePayment.check.rowVersion = this.generateUuid();
            },
            onBankChange2(val) {
                this.fromTitle = "دسته چک بانک " + val.outSourceName;
                // if (this.transactionType === 'payment') {
                this.activePayment.check.checkExporterBankId = val.id;
                this.activePayment.check.rowVersion = this.generateUuid();
                // } else {
                //     this.activePayment.check.checkExporterBankId = val.id;
                // }
            },
            toggleDatePicker() {
                this.$refs.datePicker.togglePicker();
            },
            onDatePicked(val) {
                this.activePayment.check.checkDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.activePayment.check.checkPersianDate = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            resetDate() {
                this.activePayment.check.checkPersianDate = '';
                this.activePayment.check.checkDate = '';
            },
            onCheckModalOk() {
                let payment = JSON.parse(JSON.stringify(this.activePayment));
                payment.price = parseInt(payment.price);
                this.payments.push(payment);
                if (this.transactionType === 'sell') {
                    this.hasCheck = true;
                }
                // this.customerChecks.push(payment);
                Utils.resetObject(this.activePayment.check);
                // this.activePayment.price = 0;
                this.activePayment.code = "";

                // let payment = JSON.parse(JSON.stringify(this.activePayment));
                payment.check.rowVersion = this.generateUuid();
                this.activePayment.usedCheck = true;
                this.activePayment.code = null;
                this.activePayment.check = payment.check;
                $("#check").modal('hide');
                this.onPaymentModalOk();
            },
            onTransactionSubmitClicked() {
                if (this.voucher.voucherDate === undefined || this.voucher.voucherDate === null || this.voucher.voucherDate === "" || this.voucher.voucherDate === "0001-01-01") {
                    this.voucher.voucherDate = Moment(new Date()).format('YYYY-MM-DD');
                }
                if (this.checkVoucherDateInSalemali(this.voucher.voucherDate)) {
                    if (!this.isSending) {
                        this.isSending = true;
                        if (isNaN(this.voucher.receiveOutSourceId)) {
                            this.voucher.receiveOutSourceId = "";
                        }
                        for (let item of this.payments) {
                            if (item.check.checkNumber === "") {
                                item.check = null;
                            }
                        }
                        new BaseService('voucher').create(this.voucher).then(response => {
                            let voucherId = response.data.data;
                            new BaseService('voucher', `/payment/${voucherId}`).create(this.payments).then(response => {
                                this.$noty.success("سند با موفقیت ثبت شد!");
                                if (this.archivedVoucher) {
                                    this.removeVoucherFromArchives(this.voucher.type, this.voucher.voucherIndex);
                                }
                                $("#customer").modal("hide");
                                this.$router.push({name: 'home'});
                            }).catch(error => {
                                Utils.handleErrorWithNotification(error.response.message, this.$noty);
                            })
                            this.isSending = false;
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        });
                    }
                }
            },
            onCustomerAssignmentClicked() {
                if (this.remainingAmount < 0) {
                    this.$noty.error("مبلغ باقیمانده منفی میباشد!")
                } else {
                    this.queryParams.types = 1;
                    new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                        this.customers = response.data.data;
                        $("#loading-customer").hide();
                        $("#customer").modal("show");
                    }).catch(error => {
                        // error
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                }
            },
            onCustomerClicked(index) {
                this.voucher.receiveOutSourceId = this.customers[index].id;
                this.onVoucherSubmitClicked();
            },
            removeVoucherFromArchives(type, index) {
                if (type === 'buy') {
                    let archives = JSON.parse(localStorage.getItem("tempVoucherBuy"));
                    archives.splice(index, 1);
                    localStorage.setItem("tempVoucherBuy", JSON.stringify(archives));
                } else {
                    let archives = JSON.parse(localStorage.getItem("tempVoucherSell"));
                    archives.splice(index, 1);
                    localStorage.setItem("tempVoucherSell", JSON.stringify(archives));
                }
            },
            thousandSeprator(a) {

                let amount = a;
                let showprice = "";

                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                this.activePayment.priceShow = showprice;

            },
            thousandSepratorReturn1(a) {
                this.price2 = 0;
                this.price2show = "0";
                let amount = a;
                let showprice = "";
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                this.price1show = showprice;
                // return b;
            },
            thousandSepratorReturn2(a) {
                this.price1 = 0;
                this.price1show = "0";
                let amount = a;
                let showprice = "";
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                this.price2show = showprice;
                // return b;
            },
            add1() {
                const cc = localStorage.getItem("salemali_close");
                if (cc !== undefined && cc != null && cc === "true") {
                    Utils.handleErrorWithNotification("سال مالی بسته شده است و امکان ثبت جدید وجود ندارد", this.$noty);
                } else {
                    if (this.secSell1.outSourceName === undefined) {
                        this.$noty.error("لطفا سرفصل را انتخاب کنید.");
                    } else if (this.price1 <= 0 && this.price2 <= 0) {
                        this.$noty.error("لطفا مبلغ بدهکار یا بستانکار را وارد کنید.");
                    } else if (this.des1 === "") {
                        this.$noty.error("لطفا توضیحات را وارد کنید.");
                    } else {

                        let a = {
                            code: this.price2 !== 0 ? this.secSell1.code : "",
                            codeName: this.price2 !== 0 ? this.secSell1.outSourceName : "",
                            price: parseInt(this.price1 !== 0 ? this.price1 : this.price2 !== 0 ? this.price2 : 0),
                            toCode: this.price1 !== 0 ? this.secSell1.code : "",
                            toCodeName: this.price1 !== 0 ? this.secSell1.outSourceName : "",
                            description: this.des1,
                        };
                        this.paymentList.push(a);
                        this.remainAmount -= parseInt(this.price1);
                        this.remainAmount += parseInt(this.price2);

                        this.totalDebt += parseInt(this.price1);
                        this.totalCreat += parseInt(this.price2);

                        this.activePayment.price += parseInt(this.price2);

                        if (this.activePayment.toCode === "" && this.price1 !== 0) {
                            this.activePayment.toCode = a.toCode;
                            this.activePayment.toName = a.toCodeName;
                        }
                        if (this.activePayment.code === "" && this.price2 !== 0) {
                            this.activePayment.code = a.code;
                            this.activePayment.name = a.name;
                        }
                        this.mainSel1 = {};
                        this.secSell1 = {};
                        this.price1show = "";
                        this.price2show = "";
                        // this.des1 = "";
                        this.price1 = 0;
                        this.price2 = 0;
                    }
                }
            },
            add2() {
                if (this.secSell2.outSourceName === undefined) {
                    this.$noty.error("لطفا دریافت کننده را انتخاب کنید.");
                } else if (this.price2 <= 0) {
                    this.$noty.error("لطفا مبلغ را وارد کنید.");
                } else if (this.des2 === "") {
                    this.$noty.error("لطفا توضیحات را وارد کنید.");
                } else {
                    let a = {
                        code: "",
                        codeName: "",
                        price: parseInt(this.price2),
                        toCode: this.secSell2.code,
                        toCodeName: this.secSell2.outSourceName,
                        description: this.des2,
                    };
                    this.paymentList.push(a);
                    this.remainAmount -= parseInt(this.price2);
                    this.totalDebt += parseInt(this.price2);
                    // this.totalCreat += this.price1;
                    // this.activePayment.price += this.price1;
                    if (this.activePayment.toCode === "") {
                        this.activePayment.toCode = this.secSell2.code;
                        this.activePayment.toName = this.secSell2.outSourceName;
                    }
                    this.price2 = 0;
                    this.price2show = "";
                    this.mainSel2 = "";
                    this.secSell2 = "";
                    this.des2 = "";
                }
            },
            editRow(item) {
                console.log(item)
                if (item && (item.code || item.toCodeName)) {
                    if (item.code === "") {  // toCode بدهکار
                        this.remainAmount += parseInt(item.price);
                        this.totalDebt -= parseInt(item.price);
                        // this.totalCreat += this.price1;
                        // this.activePayment.price = this.price1;
                    } else {
                        this.remainAmount -= parseInt(item.price);
                        // this.totalDebt -= item.price;
                        this.totalCreat -= parseInt(item.price);
                        this.activePayment.price -= parseInt(item.price);
                    }
                    this.mainSel1 = "";

                    // this.secSell1c : "",
                    //     codeName: this.price2 !== 0 ? this.secSell1.outSourceName
                    var a = {
                        code: "",
                        outSourceName: ""
                    };
                    a.code = item.codeName !== "" ? item.code : item.toCode;
                    a.outSourceName = item.codeName !== "" ? item.codeName : item.toCodeName;
                    this.secSell1 = a;
                    this.price1 = item.toCodeName !== "" ? item.price : 0;
                    this.price1show = item.toCodeName !== "" ? item.price.toLocaleString() : "";
                    this.price2 = item.codeName !== "" ? item.price : 0;
                    this.price2show = item.codeName !== "" ? item.price.toLocaleString() : "";
                    this.des1 = item.description;
                    this.paymentList.splice(this.paymentList.indexOf(item), 1);
                    // this.paymentList.splice(item);
                }

            },
            minus(item) {
                if (item && (item.code || item.toCodeName)) {
                    if (item.code === "") {  // toCode بدهکار
                        this.remainAmount += parseInt(item.price);
                        this.totalDebt -= parseInt(item.price);
                        // this.totalCreat += this.price1;
                        // this.activePayment.price = this.price1;
                    } else {
                        this.remainAmount -= parseInt(item.price);
                        // this.totalDebt -= item.price;
                        this.totalCreat -= parseInt(item.price);
                        this.activePayment.price -= parseInt(item.price);
                    }
                    this.paymentList.splice(this.paymentList.indexOf(item), 1);
                    // this.paymentList.splice(item);
                }

            },
            thousandSepratorprint(a) {

                let amount = a;
                let showprice = "";

                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                return showprice;

            },
            toggleStartDatePicker() {
                console.log("lcikndkdk")
                this.$refs.datePickerStart.togglePicker();
            },
            toggleStartDatePicker2() {
                console.log("lc2")
                this.$refs.datePickerStart2.togglePicker();
            },
            onStartDatePicked(val) {
                this.activePayment.voucherDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.voucherDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            resetStartDate() {
                this.activePayment.voucherDate = "0001-01-01";
                this.voucherDatePersian = '';
            },
            onDept1Select(val) {
                console.log("onDept1Select")
                if (val) {
                    this.mainSel1 = val;

                    if (val.id === 0) {
                        this.selectedMain1 = val.id;
                        this.queryParams.outsourceType = this.selectedMain1;
                    } else {
                        this.selectedMain1 = parseInt(val.code);
                        this.queryParams1.outsourceType = this.selectedMain1;

                    }
                    this.queryParams1.pageIndex = 0;
                    this.queryParams1.types = this.selectedMain1;
                    this.getProviders1();
                } else {
                    this.mainSel1 = {};
                    this.secSell1 = {};
                }
            },
            onDept2Select(val) {
                console.log("onDept2Select")
                if (val) {
                    this.secSell1 = val;
                    if (this.activePayment.code === "") {
                        this.activePayment.code = this.secSell1.code;
                        this.activePayment.name = this.secSell1.outSourceName;
                    }
                    this.activePayment.fromCode = null;
                } else {
                    this.secSell1 = {};
                }

            },
            getProviders1() {
                new BaseService('outsource', '/getlist').getList(this.queryParams1).then(response => {
                    this.cashs1 = response.data.data;
                    // console.log(this.banks);
                    let allPro = {
                        id: 0,
                        outSourceName: "همه موارد"
                    };
                    // this.banks.push(allPro);
                }).catch(error => {
                    console.log(error)
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onCreat1Select: function (val) {
                if (val && val.id) {
                    this.mainSel2 = val;
                    if (val.id === 0) {
                        this.selectedMain2 = val.id;
                        this.queryParams.outsourceType = this.selectedMain2;
                    } else {
                        this.selectedMain2 = val.id;
                        this.queryParams2.outsourceType = this.selectedMain2;

                    }
                    this.queryParams2.pageIndex = 0;
                    this.queryParams2.types = this.selectedMain2;
                    this.getProviders2();
                }

            },
            onCreat2Select(val) {
                if (val && val.id) {
                    this.secSell2 = val;
                    if (this.activePayment.toCode === "") {
                        this.activePayment.toCode = this.secSell2.code;
                        this.activePayment.toName = this.secSell2.outSourceName;
                    }
                }

            },
            getProviders2() {
                new BaseService('outsource', '/getlist').getList(this.queryParams2).then(response => {
                    this.cashs2 = response.data.data;
                    // console.log(this.banks);
                    let allPro = {
                        id: 0,
                        outSourceName: "همه موارد"
                    };
                    // this.banks.push(allPro);
                }).catch(error => {
                    console.log(error)
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },


        },

        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#payment").hasClass("show")) {
                $("#payment").modal("hide");
                next(false);
            } else {
                if ($("#check").hasClass("show")) {
                    $("#check").modal("hide");
                    next(false);
                } else {
                    if ($("#customer").hasClass("show")) {
                        $("#customer").modal("hide");
                        next(false);
                    } else {
                        if ($("#transaction").hasClass("show")) {
                            $("#transaction").modal("hide");
                            next(false);
                        } else {
                            next();
                        }
                    }
                }
            }


        },
    }
</script>